import styled, { css } from 'styled-components';
import {
  colorStyle, typography, border, space, layout,
} from 'styled-system';
import { themeGet } from '@styled-system/theme-get';
import { Link } from 'gatsby-plugin-intl';

interface LinkProps {
  $primary?: boolean;
  $secondary?: boolean;
  $blue?: boolean;
  $footer?: boolean;
  $black?: boolean;
  $submenu?: boolean;
  $lineHeight?: string;
  $unstyled?: boolean;
  isSpecialLink?: boolean;
  internal?: boolean;
  href?: string;
}

const LinkStyles = css<LinkProps>`
  font-weight: ${(props) => {
    if (props.$footer) return themeGet('fontWeights.regular');
    if (props.$submenu) return themeGet('fontWeights.normal');
    if (props.$black) return 'inherit';
    return themeGet('fontWeights.medium');
  }};
  font-size: ${({ $black }) => $black ? 'inherit' : '14px'};
  line-height: ${({ $lineHeight }) => $lineHeight || '18px'};
  letter-spacing: 0.2px;
  transition: color 300ms ease;
  color: ${(props) => {
    if (props.$primary) return themeGet('colors.red');
    if (props.$secondary) return themeGet('colors.black');
    if (props.$blue) return themeGet('colors.blue');
    if (props.$footer) return themeGet('colors.white');
    if (props.$black) return themeGet('colors.black');
    return themeGet('colors.black');
  }};

  :lang(fr) {
    line-height: 20px;
  }

  span {
    text-decoration: ${({ $secondary, $black }) => $secondary || $black ? 'underline' : 'none'};
    text-underline-offset: ${({ $secondary, $black }) => $secondary || $black ? '0.1rem' : 'auto'};
  }

  &:hover,
  &:focus {
    color: ${(props) => {
    if (props.$primary) return themeGet('colors.reds.1');
    // if (props.$secondary) return themeGet('colors.blues.1');
    if (props.$blue) return themeGet('colors.blues.1');
    return '';
  }};
    opacity: ${({ $primary, $blue, $unstyled }) => $primary || $blue || $unstyled ? 1 : 0.8};
  }
  
  ${space}
  ${layout}
  ${colorStyle}
  ${typography}
  ${border}
`;

export const InternalLink = styled(Link)<LinkProps>`
  ${LinkStyles}
`;

export const ExternalLink = styled('a')`
  ${LinkStyles}
`;

// Link gets internal prop. True if internal link / false if external
// If link is internal, use gatsby link
const StyledLink = styled.a.attrs<LinkProps>(({ internal }) => ({
  as: internal ? Link : 'a',
  target: internal ? 'none' : '_blank',
}))`
  font-weight: ${themeGet('fontWeights.semibold')};
  font-size: 14px;
  line-height: ${({ $lineHeight }) => $lineHeight || '18px'};
  letter-spacing: 0.2px;

  ${colorStyle}
  ${typography}
  ${border}
  ${space}
`;

export default StyledLink;
